import { render, staticRenderFns } from "./uploadClientIdModal.vue?vue&type=template&id=7ab1efdc"
import script from "./uploadClientIdModal.vue?vue&type=script&lang=js"
export * from "./uploadClientIdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports